import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { registerPwaServiceWorker } from './pwa'
import { installDiagnostics } from './lib/diagnostics'
import { captureAttribution } from './utils/attribution'

// Install diagnostics BEFORE React mounts so the very first render's
// errors + fetches are captured too. Wrappers are idempotent —
// safe under React 18 StrictMode double-invocation.
installDiagnostics()

// A visitor arriving through a shared short link carries ?ref=<code>;
// remember it so the public forms can credit the share (30 days).
captureAttribution()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

registerPwaServiceWorker()
